import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const clientId = "254698602880-pbkipcqj6iam7pqn3q1mob8im90s9o8k.apps.googleusercontent.com";

ReactDOM.render(
    <React.StrictMode>
        <App clientId={clientId} />
    </React.StrictMode>,
    document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
